import React from "react";

export default function Product() {
  return (
    <>
      <div className="product">
        <div>
          <h1 style={{fontFamily: '"Fasthand", cursive', color:"#ffc200", fontSize:"50px"}}>Types of Product in our Restaurant are Following</h1>
        </div>
        <div className="dishcontainer1">
          <div className="dish1">
            <img src="./images/dish1.png" alt="" />
            <h3 style={{ paddingTop: "10px" }}>Fried Chicken</h3>
            <p style={{ textAlign: "justify", padding:"0 12%" }}>
              Most Selling item of our Restaurant and have a Excellant Feedback.
              Fried chicken, also known as Southern fried chicken, is a dish
              consisting of chicken pieces that have been coated with seasoned
              flour or batter and pan-fried, deep fried, pressure fried, or air
              fried. The breading adds a crisp coating or crust to the exterior
              of the chicken while retaining juices in the meat.
            </p>
            <button type="button" class="btn btn-warning" style={{color: "white",
    marginLeft: '12px'}}>ORDER NOW</button>          </div>
          <div className="dish2">
            <img
              src="./images/dish2.png"
              alt=""
              style={{
                height: "289px",
                paddingTop: "19px",
              }}
            />
            <h3 style={{ paddingTop: "10px" }}>Fried MeatBalls</h3>
            <p style={{ textAlign: "justify", padding:"0 12%" }}>
              Most Selling item of our Restaurant and have a Excellant Feedback.
              A meatball is ground meat rolled into a ball, sometimes along with
              other ingredients, such as bread crumbs, minced onion, eggs,
              butter, and seasoning.[1] Meatballs are cooked by frying, baking,
              steaming, or braising in sauce. There are many types of meatballs
              using different types of meats and spices. The term is sometimes
              extended to meatless versions based on vegetables or fish; the
              latter are also commonly known as fishballs.
            </p>
            
            <button type="button" class="btn btn-warning" style={{color: "white",
    marginLeft: '12px'}}>ORDER NOW</button>
          </div>
          <div className="dish3">
            <img
              src="./images/dish3.png"
              alt=""
              style={{
                height: "289px",
                paddingTop: "19px",
              }}
            />
            <h3 style={{ paddingTop: "10px" }}>Pad Thai</h3>
            <p style={{ textAlign: "justify", padding:"0 12%" }}>
              Most Selling item of our Restaurant and have a Excellant Feedback.
              Pad thai is made with rice noodles, which are stir fried with eggs
              and chopped firm tofu, flavored with tamarind juice, fish sauce,
              dried shrimp, garlic, shallots, may add red chili pepper and palm
              sugar, and served with lime wedges and often crushed roasted
              peanuts.[3][4][5] It may contain other vegetables like bean
              sprouts, garlic chives, preserved radish [zh], and raw banana
              flowers. It may also contain fresh shrimp, crab, squid, chicken or
              other fish or meat.[4][5]
            </p>
            <button type="button" class="btn btn-warning" style={{color: "white",
    marginLeft: '12px'}}>ORDER NOW</button>          </div>
        </div>
      </div>
    </>
  );
}
